import { useEffect } from "react"

const POLLING_INTERVAL_MS = 5000

const fetchTopic = async path => {
  const response = await fetch(path)
  const data = await response.json()
  return data.notification
}

export const useTopicUpdater = ({ path, status, onUpdate }) => {
  useEffect(() => {
    if (status !== "processing") return

    let timeoutId
    let cancelled = false

    const poll = async () => {
      try {
        const data = await fetchTopic(path)
        if (!cancelled) {
          onUpdate(data)
        }
      } catch (error) {
        console.error(error)
      } finally {
        if (!cancelled) {
          timeoutId = window.setTimeout(poll, POLLING_INTERVAL_MS)
        }
      }
    }

    timeoutId = window.setTimeout(poll, POLLING_INTERVAL_MS)

    return () => {
      cancelled = true
      window.clearTimeout(timeoutId)
    }
  }, [path, status, onUpdate])
}
